<template>
  <main class="main" role="main">
    <div class="main__inner bg"><!-- 배경: bg-->
      <div class="main__con">

        <!-- 메인 배너 제거 서비스 진행상황 추가-->
        <!--        <div class="swiper_wrapper">-->
        <!--          <swiper ref="mySwiper" class="mySwiper" :options="swiperOption" v-if="bannerList.length > 0">-->
        <!--            <swiper-slide class="swiper_slide" v-for="(item, index) in bannerList" :key="index">-->
        <!--              <div class="swiper_slide">-->
        <!--                <img :src="$Util.loadImage(480, item.bannerImage)" alt=""/>-->
        <!--              </div>-->
        <!--              <span class="rolling_slide">{{ index + 1 }} / {{ bannerList.length }}</span>-->
        <!--            </swiper-slide>-->
        <!--          </swiper>-->
        <!--          <div class="swiper-dummy" v-else>NO IMAGE</div>-->
        <!--        </div>-->
        <!--        <div class="line"></div>-->

        <div class="notice-wrap" v-if="isLoad">
          <div class="notice-title">
            <div class="title">
              <span>제공 서비스</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="category-content">
            <div class="category_box">
              <div class="category" v-if="isElect === -1 || $Util.isEmpty(electData)">
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/electric.png" alt="전력비">
                    <p class="ttl">전력비</p>
                  </div>
                  <div class="tag_box">
                    <span class="tag">비용부담zero 효율의극대화</span>
                  </div>
                </div>
                <div class="category_btm">
                  <button type="button" class="btn_inquire" @click="$router.replace('/main/message')">도입하기</button>
                </div>
              </div>
              <div class="category" v-else>
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/electric.png" alt="전력비">
                    <p class="ttl">전력비 절감</p>
                    <div class="box__con__ttl">
                      <span class="status status__work blink">{{ electData.serviceStatus === 100 ? '관리중' : '진행중' }}</span>
                    </div>
                  </div>
                  <div class="tag_box" v-if="electData.serviceStatus === 100">
                    <span class="tag">전력비 절감 관리중 입니다.</span>
                  </div>
                  <div class="tag_box" v-else>
                    <span class="tag">[{{ $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].label }}]</span>
                    <span class="tag">{{ $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].description }}</span>
                  </div>
                </div>
                <div class="category_btm" @click="$router.push(electData.serviceStatus === 100 ? '/main/report' : '/main/progress')">
                  <span style="font-size: 1.2rem">{{ electData.serviceStatus === 100 ? '절감 보고서 확인' : '진행현황 확인' }}
                    <i class="i_right_gr18"></i>
                  </span>
                </div>
              </div>

              <!--              <div class="category color" v-if="isLabor === -1">-->
              <!--                <div class="category_top">-->
              <!--                  <div class="ttl_box">-->
              <!--                    <img src="@/assets/static/images/labor.png" alt="노무,인증">-->
              <!--                    <p class="ttl">노무</p>-->
              <!--                  </div>-->
              <!--                  <div class="tag_box">-->
              <!--                    <span class="tag">채용부터 퇴직 관리까지 합법적이고 생산적인 노무 관리</span>-->
              <!--                  </div>-->
              <!--                </div>-->
              <!--                <div class="category_btm">-->
              <!--                  <button type="button" class="btn_inquire" @click="$router.replace('/main/message')">도입하기</button>-->
              <!--                </div>-->
              <!--              </div>-->

              <div class="category color" v-else>
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/labor.png" alt="노무">
                    <p class="ttl">노무</p>
                    <div class="box__con__ttl">
                      <span class="status status__work blink">관리중</span>
                    </div>
                  </div>
                  <div class="tag_box">
                    <span class="tag"></span>
                  </div>
                </div>
                <div class="category_btm">
                  <img src="@/assets/static/images/labor.png" alt="노무">
                </div>
              </div>

              <div class="category color" v-if="isCert === -1">
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/certificate.png" alt="인증">
                    <p class="ttl">인증</p>
                  </div>
                  <div class="tag_box">
                    <span class="tag">체계적인관리시스템</span>
                  </div>
                </div>
                <div class="category_btm">
                  <button type="button" class="btn_inquire" @click="$router.replace('/main/message')">도입하기</button>
                </div>
              </div>
              <div class="category color" v-else>
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/certificate.png" alt="노무,인증">
                    <p class="ttl">인증</p>
                    <div class="box__con__ttl">
                      <span class="status status__work blink">관리중</span>
                    </div>
                  </div>
                  <div class="tag_box">
                    <span class="tag">
                      <table class="cert-table">
                        <tr v-for="(cert, index) in certData" :key="index"
                            v-if="!$Util.isEmpty(cert.progress)">
                          <th>{{ cert.progress }}</th>
                          <td class="cert-progress" v-if="cert.isComplete === -1">진행중</td>
                          <td class="cert-complete" v-else>완료</td>
                        </tr>
                      </table>
                    </span>
                  </div>
                </div>
                <div class="category_btm" @click="$router.push('/cert')">
                  <span style="font-size: 1.2rem;">진행현황 확인
                    <i class="i_right_gr18"></i>
                  </span>
                </div>
              </div>

              <div class="category color" v-if="isLab === -1">
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/lab.png" alt="연구소">
                    <p class="ttl">연구소</p>
                  </div>
                  <div class="tag_box">
                    <span class="tag">설립부터 사후관리까지</span>
                  </div>
                </div>
                <div class="category_btm">
                  <button type="button" class="btn_inquire" @click="$router.replace('/main/message')">도입하기</button>
                </div>
              </div>
              <div class="category color" v-else>
                <div class="category_top">
                  <div class="ttl_box">
                    <img src="@/assets/static/images/lab.png" alt="연구소">
                    <p class="ttl">연구소 관리</p>
                    <div class="box__con__ttl">
                      <span class="status status__work blink">관리중</span>
                    </div>
                  </div>
                  <div class="tag_box">
                    <span class="tag"></span>
                  </div>
                </div>
                <div class="category_btm" v-if="isLab === -1">
                  <button type="button" class="btn_inquire" @click="$router.replace('/main/message')">도입문의</button>
                </div>
                <div class="category_btm" @click="$router.push('/lab')" v-else>
                  <span style="font-size: 1.2rem;">진행현황 확인
                    <i class="i_right_gr18"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="line"></div>
        <div class="notice-wrap">
          <div class="notice-title">
            <div class="title">
              <span>공지사항</span>
              <button type="button" @click="$router.push('/mypage/notice')">더보기<i class="i_right_gr50"></i></button>
            </div>
          </div>
          <div class="line"></div>
          <div class="notice-content">
            <ul v-if="noticeList.length > 0">
              <li v-for="(notice, index) in noticeList" :key="index" @click="$router.push(`/mypage/noticeDetail?boardNo=${notice.boardNo}`)">
                <div class="notice-item-title">{{ notice.boardTitle }}</div>
                <div class="notice-item-date">{{ $Util.dateFormat(notice.regDate, 'YYYY.MM.DD') }}</div>
              </li>
            </ul>
            <div v-else>
              <div class="complete">
                <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img no-margin">
                <span class="complete__txt__type02">내역이 없습니다.</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 고객사례 제거 해야하는데 위치 바꿔만 놓음 -->
        <!--        <div class="line"></div>-->
        <!--        <div class="youtube-wrap">-->
        <!--          <div class="youtube-title">-->
        <!--            <div class="title">-->
        <!--              <span>고객사례</span>-->
        <!--              <button type="button" @click="$router.push('/main/case')">더보기<i class="i_right_gr50"></i></button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="line"></div>-->
        <!--          <div class="youtube-content" style="background-color: #FAFAFA;" v-if="customerCaseList.length > 0">-->
        <!--            <div class="youtube-content-list" v-for="(customerCase, index) in customerCaseList" :key="index">-->
        <!--              <div class="thumbnail-image">-->
        <!--                <iframe style="width: 100%; height: 100%;" :src="`https://www.youtube.com/embed/${customerCase.youtubeURL}`" frameborder="0"-->
        <!--                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
        <!--              </div>-->
        <!--              <div class="thumbnail-title">-->
        <!--                {{ customerCase.caseTitle }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div v-else>-->
        <!--            <div class="complete">-->
        <!--              <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img no-margin">-->
        <!--              <span class="complete__txt__type02">내역이 없습니다.</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!--        <div class="line"></div>-->
        <!--        <div class="partner-wrap">-->
        <!--          <div class="partner-title">-->
        <!--            <div class="title">-->
        <!--              <span>고객사</span>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="line"></div>-->
        <!--          <div class="partner-content">-->
        <!--            <ul v-if="partnerList.length > 0">-->
        <!--              <li v-for="(partner, index) in partnerList" :key="index">-->
        <!--                <div class="partner-item-image">-->
        <!--                  <img :src="$Util.loadImage(240, partner.partnerLogoImage)" alt=""/>-->
        <!--                </div>-->
        <!--                <div class="partner-item-title">{{ partner.partnerName }}</div>-->
        <!--              </li>-->
        <!--            </ul>-->
        <!--            <div v-else>-->
        <!--              <div class="complete">-->
        <!--                <img src="@/assets/static/images/img_notice.svg" alt="" class="complete__img no-margin">-->
        <!--                <span class="complete__txt__type02">내역이 없습니다.</span>-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
    </div>
  </main>
</template>
<script>
export default {
  components: {},
  data: function () {
    return {
      isLoad: false,
      bannerList: [],
      noticeList: [],
      customerCaseList: [],
      partnerList: [],
      isElect: -1,
      isLabor: -1,
      isLab: -1,
      isCert: -1,
      electData: {},
      certData: []
    }
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  mounted() {
    if (this.$Util.isApp() && !this.$Util.isNewApp()) {
      this.$Util.modalAlert(`새로운 앱이 출시되었습니다.<br/>기존 앱 제거 후 ${this.$Util.isIPhone() ? '앱스토어에서' : '플레이스토어에서'} KS기업누리를 검색해 주세요.`);
    }
  },
  created: async function () {
    await this.$AccountSvc.refreshUserData();

    if (this.$Util.isEmpty(this.userData)) {
      await this.$router.replace('/account/login')
    }


    await this.getMainData()
    this.$EventBus.$emit('HeaderBar.getUserPushLogUnreadCount')
  },
  methods: {
    getMainData: async function () {
      const params = { userNo: this.userData.userNo }
      const res = await this.$MainSvc.getMainData(params)
      const code = res.code
      // const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.isLoad = true
        this.bannerList = entity.bannerList
        this.noticeList = entity.noticeList
        this.customerCaseList = entity.customerCaseList
        this.partnerList = entity.partnerList
        this.isElect = entity.isElect
        this.isLabor = entity.isLabor
        this.isLab = entity.isLab
        this.isCert = entity.isCert
        this.electData = entity.electData
        this.certData = entity.certData
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.swiper_slide img {
  height: 100vw / 16 * 9 !important;
}

.rolling_slide {
  position: absolute;
  bottom: 1rem;
  right: 1.6rem;
  padding: 0.4rem 0 0.2rem;
  display: block;
  width: 4.6rem;
  background: rgba(33, 33, 33, 0.4);
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  color: #FFFFFF;
  border-radius: 5rem;
}

.no-margin {
  margin: 0 !important;
}

.notice-wrap {
  .notice-title {
    button {
      width: 30%;
      float: right;
      text-align: right;

      .i_right_gr50 {
        background-size: 100%;
        background-repeat: no-repeat;
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .notice-content {
    padding: 1rem 2rem;
    //background-color: white;
    min-height: 2.1rem * 5 + 2rem;

    ul {
      li {
        border-bottom: #EEEEEE solid 1px;

        div {
          display: inline-block;
          font-size: 1.4rem;
          line-height: 3.4rem;
          vertical-align: top;

          &.notice-item-title {
            width: 70%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          &.notice-item-date {
            width: 30%;
            text-align: right;
          }
        }
      }
    }
  }
}

.youtube-wrap {
  background-color: white;

  .youtube-title {
    button {
      width: 30%;
      float: right;
      text-align: right;

      .i_right_gr50 {
        background-size: 100%;
        background-repeat: no-repeat;
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .youtube-content {
    width: auto;
    overflow-x: auto;
    white-space: nowrap;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    padding-top: 1rem;
    padding-bottom: 1rem;

    &::-webkit-scrollbar {
      display: none;
    }

    .youtube-content-list {
      display: inline-block;
      width: 24rem;
      height: 24 / 16 * 9rem;
      margin-left: 2rem;

      &:last-child {
        margin-right: 2rem;
      }

      .thumbnail-image {
        width: 100%;
        height: 100%;
      }

      .thumbnail-title {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 1.4rem;
        font-weight: bold;
        margin-top: 0.4rem;
      }
    }
  }
}

.partner-wrap {
  .partner-title {
    button {
      width: 30%;
      float: right;
      text-align: right;

      .i_right {
        background-size: 100%;
        background-repeat: no-repeat;
        width: 2rem;
        height: 2rem;
      }
    }
  }

  .partner-content {
    padding-left: 2rem;
    padding-right: 2rem;

    ul {
      text-align: center;

      li {
        display: inline-block;
        vertical-align: middle;
        width: 33%;
        height: 8rem;
        padding: 1.5rem;

        .partner-item-image {
          display: inline-block;
          vertical-align: middle;

          img {
            width: 100%;
            height: 3rem;
          }
        }

        .partner-item-title {
          margin-top: 0.4rem;
        }
      }
    }
  }
}

.swiper-dummy {
  height: calc(100vw * 9 / 16);
  line-height: calc(100vw * 9 / 16);
  text-align: center;
}

.complete {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.box__con__ttl .status__work {
  border: 1px solid red;
  color: red;
  margin-left: auto;
  margin-right: 1rem;
}

.box__con__ttl .status__work {
  border: 1px solid red;
  color: red;
  margin-left: auto;
}

.category_top .box__con__ttl .status__work.blink {
  font-size: 1.4rem;
  width: 6rem;
  height: 2.5rem;
  margin: 0;
}

@keyframes blink-effect {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blink-effect 1s step-end infinite;
}

.box__con__ride {
  margin-top: 0;
}

.box__con__ride .ride {
  width: 100%;
}

.box__con .btn {
  margin-top: 0.6rem;
  margin-bottom: 0.1rem;
}

.btn .left {
  -webkit-box-flex: 1;
  flex: 1;
}

.category-content {
  background-color: #FAFAFA;
  padding: 0 1rem;

  .category {
    background-color: white;
    margin: 1rem 0;
    padding: 1.6rem 1.2rem;
    border: 1px solid #EEEEEE;
    border-radius: 0.5rem;

    .btn_inquire {
      margin-top: 1.5rem;
      background-color: #1980C3;
      color: #EEEEEE;
      height: 3rem;
      font-size: 1.4rem;
      line-height: 3rem;
      padding-left: 1rem;
      padding-right: 1rem;
      border-radius: 5px;
    }

    .category_top {
      .ttl_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #37474F;
        font-weight: 700;
        font-size: 1.8rem;
        line-height: 1.2;

        .ttl {
          flex: 1;
        }

        .new {
          width: 3.8rem;
          height: 1.8rem;
        }

        img {
          width: 3rem;
          height: 3rem;
          margin-right: 0.8rem;
        }
      }

      .tag_box {
        margin-top: 0.8rem;
        display: flex;
        flex-direction: column;
        color: #757575;
        font-size: 1.3rem;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
      }
    }

    .category_btm {
      color: #757575;
      display: flex;
      justify-content: flex-end;
      /*padding-top: 1rem;*/

      img {
        width: 4rem;
        height: 4rem;
        object-fit: cover;
      }
    }
  }
}

.cert-table {
  width: 100%;

  th {
    text-align: right;
    padding-right: 2.5rem;
    width: 50%;
  }

  td {
    width: 50%;
    text-align: left;
    padding-left: 2.5rem;
  }

  td.cert-progress {
    color: red;
  }

  td.cert-complete {
    color: blue;
  }

}
</style>
